<template>
    <div class="dropdown d-inline-block"
        :class="`drop${direction}`"
        v-click-outside="onClickOutside">
        <div @click="toggle()">
            <slot name="toggle" :isOpen="isOpen"></slot>
        </div>
        <transition name="dropdown">
            <div v-if="isOpen" class="dropdown-menu show" :class="`dropdown-menu-${align}`" aria-labelledby="dropdownMenuButton" @click="toggle()">
                <slot :toggle="toggle" :isOpen="isOpen"></slot>
            </div>
        </transition>
    </div>
</template>
<script>
import vClickOutside from 'v-click-outside'

export default {
    props: {
        align: {
            type: String,
            default: 'left'
        },
        direction: {
            type: String,
            default: 'down'
        }
    },

    directives: {
        clickOutside: vClickOutside.directive
    },

    data() {
        return {
            isOpen: false,
        }
    },
    
    methods: {
        toggle() {
            this.isOpen = !this.isOpen;
        },

        onClickOutside() {
            this.isOpen = false
        }
    }
}
</script>